export const ContactInfoFooterStyles = {
  container:
    'w-full flex flex-col bg-white items-center justify-center py-8 mt-auto',
  contactInfoContainer: 'flex flex-col items-start justify-center',
  title: 'text-blue700 self-center text-center text-16px font-bold',
  icon: 'mr-5',
  email: 'flex flex-row items-center mt-6',
  phone: 'flex flex-row items-center mt-6',
}
